/*!
 *
 * Copyright 2014 Dmytro Kerest
 */

jQuery(function ($) {
  'use strict';

  $('.ea-submit-button').on('click', e => {
    e.preventDefault();
  });

  $('#ea-confirm-popup')
    .on('show.bs.modal', function (event) {
      // console.log('show.popup', window.eaConfig);
      const formData = new FormData(document.querySelector('.eaa-form form'));
      const $modalBody = $('#ea-confirm-popup .modal-body');
      $modalBody.empty();

      formData.forEach((value, name) => {
        const label = document.querySelector('label[for='+name+']');
        
        if(label) {
          if(value instanceof File) {
            $modalBody.append('<h3>'+label.innerText+'</h3>');
            $modalBody.append(value.name);
            try{
              const existingFileName = label.closest('.form-group').querySelector('.existing-file span');
              if(existingFileName) {
                $modalBody.append(existingFileName.innerText);
              }  
            } catch(e) {

            }
          } else {
            if(window.eaConfig[name]) {
              $modalBody.append('<h3>'+label.innerText+'</h3>');
              if(name == 'share_contact_information') {
                $modalBody.append('Yes');
              } else {
                $modalBody.append(window.eaConfig[name][value]);
              }
              
              // console.log(label.innerText, window.eaConfig[name][value])
            } else {
              $modalBody.append('<h3>'+label.innerText+'</h3>');
              $modalBody.append(value);

              // console.log(label.innerText, value)
            }
          }


        }

      });

    })
    .on('hide.bs.modal', function () {
      // console.log('hide.popup');
    });

  $('#ea-form-submit').on('click', () => {
    $('.eaa-form form').submit();
  });

});
